import * as types from './action-types'

export const fetchAdminClientApplications = ({ options }) => ({
  type: types.ADMIN_CLIENT_APPLICATIONS_FETCH_BEGIN,
  options,
})
